<template>
  <v-container class="mt-5">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <v-card v-if="event">
          <v-card-title class="text-uppercase">
            <v-btn class="mr-3" @click="$router.back()" text>
              <v-icon left>mdi-arrow-left</v-icon>
              Back
            </v-btn>

            Event Code: {{ event.no }} &nbsp;

            <v-chip
              dark
              :color="
                event.status === 'Active' ? 'green darken-1' : 'grey darken-1'
              "
            >
              {{ event.status }}</v-chip
            >
          </v-card-title>

          <v-divider />

          <v-alert
            v-if="!!alert.status"
            border="left"
            :type="alert.status"
            class="mb-5"
          >
            {{ alert.message }}
          </v-alert>

          <v-row class="mt-5">
            <v-col cols="12" md="10" offset-md="1">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="8">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Event</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ event.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Dates</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ formatDate(event.startDate, 6) }} -
                          {{ formatDate(event.endDate, 6) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Location</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ event.location }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-img />

                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>Bookings</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ event.slotsAvailable - event.remainingSlots }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-btn
                      outlined
                      class="mb-1"
                      color="primary"
                      block
                      @click="getReport('eventAttandance', event.no)"
                      >ATTENDANCE report</v-btn
                    >
                    <v-btn
                      outlined
                      class="mb-1"
                      color="primary"
                      block
                      @click="getReport('dailyAttendanceReport', event.no)"
                      >ATTENDANCE PER DAY</v-btn
                    >
                    <v-btn
                      outlined
                      class="mb-1"
                      color="primary"
                      block
                      @click="
                        getReport('attendancePackageConsumption', event.no)
                      "
                      >PACKAGE CONSUMPTION</v-btn
                    >
                    <v-btn
                      outlined
                      class="mb-1"
                      color="primary"
                      block
                      :to="{
                        name: 'DelegatesBio',
                        params: { event: event.no },
                      }"
                      >Delegates</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>

              <v-data-table
                v-if="event"
                :headers="headers"
                :items="filterPackages(event.eventPackageCost)"
                class="elevation-1 my-10"
                hide-default-footer
                :items-per-page="100"
              >
                <template v-slot:item.mandatory="{ item }">
                  {{ item.mandatory ? "Yes" : "No " }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    :to="{
                      name: 'Delegates',
                      params: { event: item.eventNo, package: item.packageNo },
                    }"
                    dark
                    color="primary"
                  >
                    Check in
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>

        <v-card v-else>
          <v-skeleton-loader type="card-heading, table" />
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="reportDialog"
      persistent
      max-width="450"
      :disabled="$store.getters['loading']"
    >
      <v-card :loading="$store.getters['loading']">
        <v-card-title class="text-h6 text-capitalize">
          Report
          <v-spacer />
          <v-btn text @click="reportDialog = false">Close</v-btn>
        </v-card-title>

        <v-card-actions>
          <v-btn text :href="report" color="primary">
            Download
            <v-icon right>mdi-download</v-icon>
          </v-btn>

          <v-spacer />

          <v-btn
            color="secondary"
            text
            target="_blank"
            :href="`https://docs.google.com/gview?url=${report}`"
          >
            Open
            <v-icon right>mdi-link</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DateMixin from "@/modules/mixins/DateMixin";
import FileMixin from "@/modules/mixins/FileMixin";

export default {
  name: "Event",

  data: function () {
    return {
      headers: [
        {
          text: "Package Code",
          align: "start",
          sortable: false,
          value: "packageNo",
        },
        { text: "Package description", value: "description" },
        { text: "Mandatory", value: "mandatory" },
        { text: "Category", value: "membershipCategory" },
        { text: "Action", value: "action" },
      ],
      reportDialog: false,
      // currEvent: [],
    };
  },

  mixins: [DateMixin, FileMixin],

  beforeRouteEnter(to, from, next) {
    next((v) => {
      let no = to.params.code;
      v.$store.dispatch("Dashboard/getEvent", no);
      v.$store.commit("Dashboard/SET_REPORT", "");
    });
  },

  computed: {
    event() {
      return this.$store.getters["Dashboard/event"];
    },

    report() {
      return this.$store.getters["Dashboard/report"];
    },

    alert() {
      return this.$store.getters["Dashboard/alert"];
    },
  },

  methods: {
    getReport: function (report, eventCode) {
      this.$store.dispatch("Dashboard/getReport", {
        report: report,
        eventNo: eventCode,
      });
    },
    filterPackages(packages) {
      // group packages by packageNo and select the first one
      if (!packages) return [];

      return packages
        .reduce((acc, curr) => {
          const x = acc.find((item) => item.packageNo === curr.packageNo);
          if (!x) {
            return acc.concat([curr]);
          } else {
            return acc;
          }
        }, [])
        .map((item) => {
          return {
            ...item,
          };
        });
    },
  },

  watch: {
    report: {
      handler: function (n) {
        if (n) this.reportDialog = true;
      },
    },
  },
};
</script>

<style scoped></style>
